export const RESEND_MAIL_TYPE = {
	FORGOR_PASSWORD: 'forgot-password',
	CREATE_PASSWORD: 'create-password',
};

export const QK_PROFILE = '/users/me';
